import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCancel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M11.2882 8.90404L10.3362 7.95202L11.3539 6.5404L9.02304 3.25758H5.64173L4.3286 1.94444H9.02304C9.2419 1.94444 9.44434 1.99106 9.63037 2.08429C9.81639 2.17753 9.97506 2.31694 10.1064 2.50253L12.9624 6.5404L11.2882 8.90404ZM12.1746 13.5L9.64678 10.9722C9.5483 11.0269 9.44981 11.0681 9.35133 11.0957C9.25284 11.1232 9.14341 11.1368 9.02304 11.1364H2.45739C2.09628 11.1364 1.78703 11.0077 1.52966 10.7503C1.27229 10.4929 1.14382 10.1839 1.14426 9.82323V3.25758C1.14426 3.13721 1.15804 3.02778 1.18562 2.92929C1.21319 2.83081 1.25412 2.73232 1.3084 2.63384L0.09375 1.41919L1.01294 0.5L13.0938 12.5808L12.1746 13.5ZM8.49779 9.82323L2.45739 3.78283V9.82323H8.49779Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgCancel);
export { ForwardRef as ReactComponent };
